import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Button, Col, Divider, Form, Input, Row, Tag, Select, Tabs } from 'antd';
import { LayerTab } from './LayerTab';
const { Option, OptGroup } = Select;
const { TabPane } = Tabs;

@withRouter
@inject('store')
@observer
class GeneralFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            long: (props.data && props.data.long) || {},
            short: (props.data && props.data.short) || {}
        };
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.store.makoBotStore.updateConfig({
                    ...values,
                    long: this.state.long,
                    short: this.state.short
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={8}>
                        <Form.Item label="Name" required={true}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col md={8}>
                        <Form.Item label="Support Key" required={true}>
                            <i className="fal fa-life-ring success" />{' '}
                            <Tag>{this.props.match.params.id}</Tag>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">API Keys</Divider>
                <Row gutter={24}>
                    <Col md={8}>
                        <Form.Item label="Api Key">
                            {getFieldDecorator('api_key')(<Input.Password />)}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Api Secret">
                            {getFieldDecorator('api_secret')(<Input.Password />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Setup</Divider>
                <Row gutter={24}>
                    <Col md={4}>
                        <Form.Item label="Symbol">
                            {getFieldDecorator('symbol', {
                                initialValue: 'BTC/USD'
                            })(
                                <Select style={{ width: '100%' }}>
                                    <Option value="BTC/USD">BTC/USD</Option>
                                    <Option value="ETH/USD">ETH/USD</Option>
                                    <Option value="XRP/USD">XRP/USD</Option>
                                    <Option value="EOS/USD">EOS/USD</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={4}>
                        <Form.Item label="Profile">
                            {getFieldDecorator('direction', {
                                initialValue: 'long'
                            })(
                                <Select style={{ width: '100%' }}>
                                    <OptGroup label="Market Maker">
                                        <Option value="mm-auto">Auto (MM))</Option>
                                        <Option value="long">Long (MM)</Option>
                                        <Option value="short">Short (MM)</Option>
                                        <Option value="mm-auto-long">Auto - Long (MM)</Option>
                                        <Option value="mm-auto-short">Auto - Short (MM)</Option>
                                    </OptGroup>
                                    <OptGroup label="Scalper">
                                        <Option value="scalper-auto">Auto (Scalp)</Option>
                                        <Option value="scalper-long">Long Only (Scalp)</Option>
                                        <Option value="scalper-short">Short Only (Scalp)</Option>
                                    </OptGroup>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Tabs type="card">
                    <TabPane tab="Long" key="1">
                        <LayerTab
                            data={this.state.long}
                            updateTab={values => {
                                let next = { ...this.state.long, ...values };
                                this.setState({ long: next });
                            }}
                        />
                    </TabPane>
                    <TabPane tab="Short" key="2">
                        <LayerTab
                            data={this.state.short}
                            updateTab={values => {
                                let next = { ...this.state.short, ...values };
                                this.setState({ short: next });
                            }}
                        />
                    </TabPane>
                </Tabs>

                <div style={{ marginTop: 15 }}>
                    <Button onClick={this.handleSubmit.bind(this)} type="primary" size="large">
                        Save
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                        onClick={() => this.props.store.makoBotStore.reboot()}
                        type="danger"
                        size="large"
                    >
                        Reboot
                    </Button>
                </div>
            </Fragment>
        );
    }
}

export const GeneralForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            if (k === 'api_key' || k === 'api_secret') return;
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(GeneralFormComponent);



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/SettingsView/GeneralForm.js